export default __webpack_public_path__ + "static/media/CarWrapping.9f2bfa83.jpg";